(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moldeva-gallery-belt"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrap = document.getElementById('mv-belt-track-wrap');
  var track = wrap && wrap.querySelector('.mv-belt-track');
  if (!track) return;
  var imgs = Array.prototype.slice.call(track.querySelectorAll('img'));
  Promise.all(imgs.map(function (im) {
    return im.complete ? Promise.resolve() : new Promise(function (r) { im.onload = im.onerror = r; });
  })).then(function () {
    build();
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(build, 150); });
  });
  function build() {
    track.style.animation = 'none';
    var n = track.dataset.count ? parseInt(track.dataset.count, 10) : track.children.length;
    track.dataset.count = String(n);
    while (track.children.length > n) track.removeChild(track.lastElementChild);
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
    var w = 0;
    for (var i = 0; i < n; i++) {
      w += track.children[i].getBoundingClientRect().width;
      if (i < n - 1) w += gap;
    }
    w = Math.ceil(w);
    for (var j = 0; j < n; j++) track.appendChild(track.children[j].cloneNode(true));
    track.style.setProperty('--mvb-loop', w + 'px');
    track.style.setProperty('--mvb-speed', Math.max(10, Math.round(w / 120)) + 's');
    void track.offsetWidth;
    track.style.animation = '';
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moldeva-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STEP = 3;

  function mvRevInit(section) {
    if (section.getAttribute('data-mv-rev-ready') === '1') return;
    section.setAttribute('data-mv-rev-ready', '1');

    var items = section.querySelectorAll('.mv-rev-item');
    var btn = section.querySelector('.mv-rev-more');
    var shown = 0;

    function reveal() {
      for (var i = shown; i < shown + STEP; i++) {
        if (items[i]) items[i].style.display = 'block';
      }
      shown += STEP;
      if (btn && shown >= items.length) btn.style.display = 'none';
    }

    reveal();
    if (btn) btn.addEventListener('click', reveal);
  }

  function mvRevBoot(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('.mv-rev');
    for (var i = 0; i < sections.length; i++) mvRevInit(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mvRevBoot(); });
  } else {
    mvRevBoot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelectorAll) mvRevBoot(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
